module.exports = __webpack_public_path__ + "img/5.6fc94386.jpg";